module.exports = __webpack_public_path__ + "img/notice.2392ec8c.svg";